import { render } from "./DashboardControlView.vue?vue&type=template&id=64764da6"
import script from "./DashboardControlView.vue?vue&type=script&lang=js"
export * from "./DashboardControlView.vue?vue&type=script&lang=js"

import exportComponent from "/home/felix/ContinuousLabs/clients/bloqs4/parribaclub/control/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__